import React from 'react'

interface CoveragePieSVGProps {
   percent: number
   size?: number
   strokeWidth?: number
   arcColor?: string
   bgColor?: string
   textColor?: string
}

export const CoveragePieSVG: React.FC<CoveragePieSVGProps> = ({
   percent,
   size = 60,
   strokeWidth = 6,
   arcColor = '#A259FF',
   bgColor = '#2D2D2D',
   textColor = '#fff',
}) => {
   const radius = (size - strokeWidth) / 2
   const circumference = 2 * Math.PI * radius
   const arcLength = (percent / 100) * circumference

   return (
      <svg width={size} height={size} style={{ background: 'transparent' }}>
         {/* Background circle */}
         <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={bgColor}
            strokeWidth={1}
            fill="none"
         />
         {/* Arc */}
         <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={arcColor}
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={`${arcLength} ${circumference - arcLength}`}
            strokeDashoffset={circumference * 0.25}
            strokeLinecap="round"
         />
         {/* Centered percent text */}
         <text
            x="50%"
            y="54%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={15}
            fontWeight={500}
            fill={textColor}
         >
            {percent}%
         </text>
      </svg>
   )
}
